export default "__VITE_ASSET__CuqX6Caq__"